import DatetimeMixin from '@/mixins/datetime-mixin';
import { USER_HISTORY_LOGS } from '@/sections/users/users-mutation-types';
import _ from 'lodash';
import Vue from 'vue';
export default {
	mixins: [DatetimeMixin],
	mounted() {
		window.addEventListener('resize', this.handleWindowSizeChange);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleWindowSizeChange);
	},
	computed: {
		getCharacterLimit() {
			const MAX_WIDTH_ALLOW = Math.ceil(this.actionClientWidth * 0.125);

			const limit = MAX_WIDTH_ALLOW;

			return limit;
		}
	},
	updated() {
		this.$nextTick(() => {
			if (this.$refs.actionWidthRef) {
				const newWidth = this.$refs.actionWidthRef.clientWidth;

				if (
					!this.actionClientWidth &&
					newWidth !== this.actionClientWidth
				) {
					this.refreshSource(newWidth);
				}
			}
		});
	},
	methods: {
		handleWindowSizeChange() {
			this.windowWidth = window.innerWidth;
		},
		filterUserHistoryLogsByCriteria() {
			let userHistoryLogs = _.cloneDeep(this[USER_HISTORY_LOGS]);
			const criteria = [
				'User',
				'Role',
				'LastName',
				'FirstName',
				'Title',
				'Active'
			];
			userHistoryLogs.items.forEach(item => {
				let { fieldChanges } = item;
				let filteredFieldChanges = [];

				if (_.isEmpty(fieldChanges)) {
					item.fieldChanges = { items: [] };
					const hasEmptyFirstItem = _.isEmpty(item.data.items?.[0]);

					if (item.action == 'Add' && hasEmptyFirstItem) {
						fieldChanges = {
							items: [
								{
									Action: 'Add',
									ChangedPropertyName: 'User',
									NewValue: item.data.items?.[1] || null
								}
							]
						};
					}
				}
				filteredFieldChanges = fieldChanges.items.reduce(
					(acc, change) => {
						if (
							criteria.some(criterion =>
								change.ChangedPropertyName.includes(criterion)
							) &&
							!change.ChangedPropertyName.includes(
								'IsGlobalEmployeeActive'
							)
						) {
							acc.push(change);
						}
						return acc;
					},
					[]
				);
				Vue.set(item.fieldChanges, 'items', filteredFieldChanges);
			});
			return userHistoryLogs;
		},
		refreshSource(newWidth) {
			this.actionClientWidth = newWidth;

			const userHistoryLogs = this.filterUserHistoryLogsByCriteria();

			if (!_.isEmpty(userHistoryLogs)) {
				this.tableSource.source = this.parseUsersHistoryLogs(
					userHistoryLogs,
					false
				);
			}
		},
		parseUsersHistoryLogs(response, isCSV) {
			const parsedResponse = this.parseUserLogs(response, isCSV);
			return parsedResponse;
		},
		parseUserLogs(response, isCSV) {
			let clonedResponse = { ...response };
			clonedResponse.items = response.items
				.filter(
					item =>
						item.fieldChanges?.items &&
						item.fieldChanges?.items.length > 0
				)
				.map(element => this.createLogItem(element));
			clonedResponse.items.forEach(item => {
				this.formatUserActionText(item, isCSV);
			});

			return clonedResponse;
		},
		createLogItem(element) {
			let item = {
				action: element.action,
				timestamp: this.fullDateString(element.timestamp, true),
				differenceDateString: this.differenceDateString(
					element.timestamp
				),
				changedByUserName: element.changedByUserName,
				data: element.data,
				fieldChanges: element.fieldChanges?.items.filter(
					i => i.ChangedPropertyName != 'email'
				)
			};
			return item;
		},
		formatUserActionText(item, isCSV) {
			const stripHtmlTags = str => str.replace(/<\/?[^>]+>/gi, '');

			const countAdditionalCommas = (originalStr, partialStr) => {
				const originalText = stripHtmlTags(originalStr);
				const partialText = stripHtmlTags(partialStr);

				const startIndex = originalText.indexOf(partialText);
				if (startIndex === -1) return 0;

				const remainingText = originalText
					.slice(startIndex + partialText.length)
					.trim();
				return (remainingText.match(/,/g) || []).length;
			};

			if (_.isEmpty(item)) return '';

			item = this.handleActions(item, isCSV);

			if (item.actionDescription && item.actionsToDisplayHTML) {
				const commas = countAdditionalCommas(
					item.actionDescription,
					item.actionsToDisplayHTML
				);
				if (commas > 0) {
					item.totalChangeDescription =
						commas > 1
							? `+${commas} more changes`
							: '+1 more change';
				}
			}

			return isCSV ? item.action : item.actionDescription;
		},
		handleActions(item, isCSV) {
			const tags = {
				bTag: isCSV ? '' : '<strong>',
				eTag: isCSV ? '' : '</strong>'
			};
			const validate = isCSV ? true : this.actionClientWidth > 0;
			const { action, fieldChanges } = item;

			let results = [];
			let actionsToDisplayHTML = '';

			if (!validate) return item;

			switch (action) {
				case 'Add':
					item = this.pushCreatedUser(item, results, tags);
					item = this.handleUpdateAction(
						item,
						results,
						actionsToDisplayHTML,
						tags
					);
					break;

				case 'Update':
					if (!fieldChanges) return item;
					item = this.handleUpdateAction(
						item,
						results,
						actionsToDisplayHTML,
						tags
					);
					break;
			}
			if (this.downloadingCSV) {
				item.action = results.join(' ');
			}
			return this.updateActionDescription(item, results, isCSV);
		},
		pushCreatedUser(item, results, tags) {
			const { eTag, bTag } = tags;
			const firstName = _.get(item, 'data.items[1].FirstName', '');
			const lastName = _.get(item, 'data.items[1].LastName', '');
			const title = _.get(item, 'data.items[1].Title', '');

			const roles = _.get(item, 'data.items[1].Roles', []);

			const internalRoles = roles
				.filter(role => role.ClientId === 'vue-support-portal')
				.map(role => role.Role)
				.join(', ');

			const externalRoles = roles
				.filter(role => role.ClientId === 'vue-support-external')
				.map(role => role.Role)
				.join(', ');

			const itemsToAdd = [];

			// Add the user information
			itemsToAdd.push(`${bTag}User${eTag} `);
			itemsToAdd.push(`${bTag}${firstName} ${lastName}${eTag}`);
			itemsToAdd.push('created ');

			// Add "with" if internalRoles or externalRoles exist
			if (internalRoles || externalRoles) {
				itemsToAdd.push('with');
			}

			// Add internal roles if they exist
			if (internalRoles) {
				const internalRolesLabel = `internal role${
					internalRoles.includes(',') ? 's' : ''
				}: ${bTag}${internalRoles}${eTag}`;
				itemsToAdd.push(internalRolesLabel);
			}

			// Add "and" if both internalRoles and externalRoles exist
			if (internalRoles && externalRoles) {
				itemsToAdd.push('and');
			}

			// Add external roles if they exist
			if (externalRoles) {
				const externalRolesLabel = `external role${
					externalRoles.includes(',') ? 's' : ''
				}: ${bTag}${externalRoles}${eTag}`;
				itemsToAdd.push(externalRolesLabel);

				if (title) {
					itemsToAdd.push(
						`${
							internalRoles ? 'with' : 'and'
						} ${bTag}Title${eTag}: ${bTag}${title}${eTag}`
					);
				}
			}

			if (!item.results) {
				this.$set(item, 'results', results);
			}

			item.results.push(...itemsToAdd);

			item = this.truncateActions(item);
			return item;
		},
		handleUpdateAction(item, results, actionsToDisplayHTML, tags) {
			const ActionMethods = {
				Update: {
					FirstName: function() {
						this.pushFirstNameLastNameChangeUser(
							item,
							results,
							tags,
							'FirstName'
						);
						return item;
					}.bind(this),
					LastName: function() {
						this.pushFirstNameLastNameChangeUser(
							item,
							results,
							tags,
							'LastName'
						);
						return item;
					}.bind(this),
					Active: function(item, results, tags) {
						this.pushStatusUser(item, results, tags);
						return item;
					}.bind(this),
					Title: function(item, results, tags) {
						this.pushTitleUser(item, results, tags, 'Update');
						return item;
					}.bind(this)
				},
				Delete: {
					Roles: function(item, results, tags) {
						this.pushRolesChangeUser(item, results, tags, 'Delete');
						return item;
					}.bind(this),
					Title: function(item, results, tags) {
						this.pushTitleUser(item, results, tags, 'Delete');
						return item;
					}.bind(this)
				},
				Add: {
					Roles: function(item, results, tags) {
						this.pushRolesChangeUser(item, results, tags, 'Add');
						return item;
					}.bind(this),
					Title: function(item, results, tags) {
						this.pushTitleUser(item, results, tags, 'Add');
						return item;
					}.bind(this)
				}
			};

			if (!_.isEmpty(item.fieldChanges)) {
				for (let i = 0; i < item.fieldChanges.length; i++) {
					const change = item.fieldChanges[i];
					const actionType = change.Action;
					let propertyName = change.ChangedPropertyName;
					if (propertyName.includes('Roles')) {
						propertyName = 'Roles';
					}
					// Check if there is a method for the specific action and property.
					if (
						ActionMethods[actionType] &&
						ActionMethods[actionType][propertyName]
					) {
						// Call the corresponding method.
						item = ActionMethods[actionType][propertyName](
							item,
							results,
							tags
						);
					}
				}
			}

			return item;
		},
		pushFirstNameLastNameChangeUser(item, results, tags, propertyName) {
			const { bTag, eTag } = tags;

			const field = item.fieldChanges.find(
				change => change.ChangedPropertyName === propertyName
			);

			const {
				NewValue: newValue = '',
				OriginalValue: originalValue = ''
			} = field || {};

			const itemsToAdd = [
				`${bTag}${propertyName}${eTag}`,
				`changed from ${bTag}${originalValue}${eTag} to ${bTag}${newValue}${eTag},`
			];

			if (!item.results) {
				this.$set(item, 'results', results);
			}

			item.results.push(...itemsToAdd);

			item = this.truncateActions(item);

			return item;
		},
		pushTitleUser(item, results, tags, action) {
			const { bTag, eTag } = tags;
			const { fieldChanges } = item;
			const formatTitleChange = (action, item, bTag, eTag) => {
				const original = `${bTag}${item.OriginalValue}${eTag}`;
				const updated = `${bTag}${item.NewValue}${eTag}`;
				const actionText =
					action === 'Add'
						? 'added'
						: action === 'Delete'
						? 'removed'
						: '';

				const changeDescriptionByAction = {
					Update: `changed from ${original} to ${updated}`,
					Delete: original,
					default: updated
				};

				const changeDescription =
					changeDescriptionByAction[action] ||
					changeDescriptionByAction['default'];

				return `${bTag}Title ${eTag}${changeDescription} ${actionText},`;
			};

			const fieldsTitleByAction = fieldChanges
				.filter(
					item =>
						item.Action === action &&
						item.ChangedPropertyName === 'Title'
				)
				.map(item => formatTitleChange(action, item, bTag, eTag));

			if (!item.results) {
				this.$set(item, 'results', results);
			}

			if (!_.isEmpty(fieldsTitleByAction)) {
				item.results.push(...fieldsTitleByAction);
			}

			item = this.truncateActions(item);
			return item;
		},
		pushStatusUser(item, results, tags) {
			const { bTag, eTag } = tags;
			const field = item.fieldChanges.find(
				change => change.ChangedPropertyName === 'Active'
			);
			const statusValue = field.NewValue === true ? 'Active' : 'Inactive';

			const itemsToAdd = [
				`${bTag}Status ${eTag}`,
				`set to ${bTag}${statusValue}${eTag},`
			];

			if (!item.results) {
				this.$set(item, 'results', results);
			}

			item.results.push(...itemsToAdd);

			item = this.truncateActions(item);
			return item;
		},
		pushRolesChangeUser(item, results, tags, action) {
			const { bTag, eTag } = tags;
			const { fieldChanges } = item;
			let rolesToInsert = [];

			// Filter and map roles by action
			const rolesByAction = fieldChanges
				.filter(
					change =>
						change.Action === action &&
						change.ChangedPropertyName.includes('Roles')
				)
				.map(change => {
					const roleValue =
						action === 'Delete'
							? change.OriginalValue.Role
							: change.NewValue.Role;
					const roleAction =
						action === 'Delete' ? 'removed' : 'added';
					return `${bTag}Role ${eTag}${bTag}${roleValue}${eTag} ${roleAction},`;
				});

			if (!item.results) {
				this.$set(item, 'results', results);
			}

			if (!_.isEmpty(item.results)) {
				rolesToInsert = rolesByAction.filter(
					newRole =>
						!item.results.some(existingRole =>
							newRole.includes(existingRole)
						)
				);
			} else {
				rolesToInsert = rolesByAction;
			}

			if (!_.isEmpty(rolesToInsert)) {
				item.results.push(...rolesToInsert);
			}

			this.truncateActions(item);
			return item;
		},
		updateActionDescription(item, results, isCSV) {
			const updatedResults = results.join(' ').trim();
			let actionDescription;

			if (item.hasTruncate && !isCSV) {
				actionDescription = `${updatedResults} ...`;
			} else {
				actionDescription = updatedResults.endsWith(',')
					? updatedResults.slice(0, -1)
					: updatedResults;
			}

			this.$set(item, 'actionDescription', actionDescription);
			return item;
		},
		truncateActions(item) {
			const actions = [...item.results];

			const actionsText = this.convertArrayToStringAndRemoveHTML(actions);
			const limit = this.getCharacterLimit;
			this.$set(item, 'hasTruncate', false);
			item.actionsToDisplayHTML = actionsText;

			const applyTruncation = actionsText.length > limit;

			if (applyTruncation) {
				this.$set(item, 'hasTruncate', true);
				item.actionsToDisplayHTML = actionsText.slice(0, limit);
			}

			return item;
		},
		convertArrayToStringAndRemoveHTML(array) {
			return array.join(' ').replace(/(<([^>]+)>)/gi, '');
		},
		exportCSV(response) {
			let rawData = this.parseUserLogs(response, true);
			const data = [['Date/Time', 'Action', 'Changed By']];

			rawData.items.forEach(change => {
				data.push([
					this.encodeCSV(
						`${change.timestamp}, ${change.differenceDateString}`
					),
					this.encodeCSV(change.actionDescription),
					this.encodeCSV(change.changedByUserName)
				]);
			});

			const csvContent = data.map(row => row.join(',')).join('\n');
			const csvFilename = 'user-history-log.csv';
			const blob = new Blob([csvContent], { type: 'text/csv' });

			const downloadLink = document.createElement('a');
			downloadLink.href = URL.createObjectURL(blob);
			downloadLink.download = csvFilename;
			downloadLink.click();
			URL.revokeObjectURL(downloadLink.href);
		},

		encodeCSV(value) {
			return value.includes(',') ? `"${value}"` : value;
		}
	},
	watch: {
		windowWidth: {
			deep: true,
			immediate: true,
			handler() {
				if (this.$refs.actionWidthRef) {
					const newWidth = this.$refs.actionWidthRef.clientWidth;
					if (newWidth != this.actionClientWidth) {
						this.refreshSource(newWidth);
					}
				}
			}
		}
	}
};
